import { render } from "./tab_produits.vue?vue&type=template&id=373a163c&scoped=true"
import script from "./tab_produits.vue?vue&type=script&lang=js"
export * from "./tab_produits.vue?vue&type=script&lang=js"

import "./tab_produits.vue?vue&type=style&index=0&id=373a163c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373a163c"]])

export default __exports__